<div class="modal-item">
  <h2 *ngIf="title" class="modal-item__title">
    {{ title | crmTranslate }}
  </h2>
  <p *ngIf="body" class="modal-item__body">
    {{ body | crmTranslate }}
  </p>

  <div class="modal-item__actions">
    <ng-container *ngIf="confirmText">
      <app-button
        class="action-item action-item--confirm"
        [title]="confirmText | crmTranslate"
        [buttonType]="confirmBtnType"
        [style]="confirmButtonStyle"
        (click)="handleConfirmClick?.()"
      ></app-button>
    </ng-container>

    <ng-container *ngIf="cancelText">
      <app-button
        class="action-item action-item--cancel"
        [buttonType]="'default'"
        [title]="cancelText | crmTranslate"
        (click)="handleCancelClick?.()"
      ></app-button>
    </ng-container>
  </div>
</div>
